import React, { useState, useEffect } from 'react';
import './App.css';
import './PageStyles.css';
import './EnhancedStyles.css';
import './QuickFactsTraining.css';
import './OTASignupForm.css';
import './AdminPage.css';
import './ContactForm.css';
import './PhotoGallery.css';
import './SponsorshipPage.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import IntroPage from './components/IntroPage';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import ProgramsPage from './components/ProgramsPage';
import TrainingPage from './components/TrainingPage';
import RegistrationPage from './components/RegistrationPage';
import CoachesPage from './components/CoachesPage';
import ResultsPage from './components/ResultsPage';
import GalleryPage from './components/GalleryPage';
import SponsorshipPage from './components/SponsorshipPage';
import StorePage from './components/StorePage';
import ContactPage from './components/ContactPage';
import AdminPage from './components/AdminPage';
import JamboreePage from './components/JamboreePage';
import PastEventsPage from './components/PastEventsPage';
import GirlsFlagPage from './components/GirlsFlagPage';
import RecruitBanner from './components/RecruitBanner';

function App() {
  const [showIntro, setShowIntro] = useState(true);
  const [hasVisited, setHasVisited] = useState(false);

  useEffect(() => {
    // Check if user has already seen the intro
    const visited = sessionStorage.getItem('panthers_intro_seen');
    if (visited) {
      setShowIntro(false);
      setHasVisited(true);
    }
  }, []);

  const handleIntroComplete = () => {
    sessionStorage.setItem('panthers_intro_seen', 'true');
    setShowIntro(false);
    setHasVisited(true);
  };

  return (
    <div className="App">
      {showIntro && <IntroPage onComplete={handleIntroComplete} />}
      <BrowserRouter>
        <RecruitBanner />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/training" element={<TrainingPage />} />
          <Route path="/registration" element={<RegistrationPage />} />
          <Route path="/coaches" element={<CoachesPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/sponsorship" element={<SponsorshipPage />} />
          <Route path="/store" element={<StorePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/jamboree" element={<JamboreePage />} />
          <Route path="/past-events" element={<PastEventsPage />} />
          <Route path="/girls-flag" element={<GirlsFlagPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
